var MvSwiper = function() {
    this.Swiper = require('Swiper');
    this.parallax = null;
};

MvSwiper.prototype  = {
    init: function() {
        var _this = this;

        var swiper = new Swiper('#js-mainvisualSlideSP', {
            pagination: '.mainvisual-slide-pagenation',
            loop: true
        });

        swiper.on('touchStart', function() {
            $('#js-mainvisualSlideSP .js-parallax').each(function(i) {
                if (!$(this).parents('.swiper-slide').hasClass('mainvisual-slide-ad')) {
                    $(this).removeClass('js-no-parallax');
                }
            });

            if (_this.parallax != null) {
                _this.parallax.scroll();
            }
        });

        swiper.on('transitionEnd', function(swiper) {
            $('#js-mainvisualSlideSP .js-parallax').each(function(i) {
                var $caption = $(this).siblings('.caption-text');
                var $title = $caption.children('div');
                var $detail = $caption.children('p');

                if (i == swiper.activeIndex) {
                    $title.addClass('caption-title-animation');
                    $detail.addClass('caption-detail-animation');

                    if ($(this).parents('.swiper-slide').hasClass('mainvisual-slide-ad')) {
                        $('#js-globalHeader').addClass('display-ad');
                        $('.mainvisual').addClass('mainvisual-ad');
                        $('#js-mainvisualSlideSP').addClass('mainvisual-ad');
                        $(this).addClass('js-no-parallax');
                    } else {
                        $('#js-globalHeader').removeClass('display-ad');
                        $('.mainvisual').removeClass('mainvisual-ad');
                        $('#js-mainvisualSlideSP').removeClass('mainvisual-ad');
                    }

                } else {
                    $(this).addClass('js-no-parallax');
                }
            });
        });
    },

    setParallax: function(object) {
        this.parallax = object;
    }
};

module.exports = MvSwiper;



/** WEBPACK FOOTER **
 ** ./src/pc/assets/js/module/MvSwiper.js
 **/